
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/ticket-stack",
      function () {
        return require("private-next-pages/design-system/ticket-stack.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/ticket-stack"])
      });
    }
  